import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { Provider as SpectrumProvider } from '@adobe/react-spectrum'
import { MuiThemeProvider } from 'material-ui/styles'

import { defaultTheme } from './themes/ideal'
import store from './redux/store'
import history from './history'
import App from './App'
import './index.css'
import {customSpectrumTheme, SPECTRUM_THEME_CLASS} from "./themes/spectrum-theme";

ReactDOM.render(
	<ReduxProvider store={store}>
		<SpectrumProvider theme={customSpectrumTheme} colorScheme={'light'} UNSAFE_className={SPECTRUM_THEME_CLASS}>
			<Router history={history} component={App}>
				<MuiThemeProvider theme={defaultTheme}>
					<App />
				</MuiThemeProvider>
			</Router>
		</SpectrumProvider>
	</ReduxProvider>,
	document.getElementById('root')
);
